import React from 'react';
import ReactDOM from 'react-dom/client';
import { ethers } from 'ethers';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import erc20ABI from './data/abis/ERC20.json';
import { getProvider } from 'utils/providers';
import { ChainId } from 'utils/chains';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const globalWindow: any = window;
globalWindow.ethers = ethers;
globalWindow.erc20ABI = erc20ABI;
globalWindow.provider = getProvider(ChainId.MATIC);
